import Moment from 'moment';
import calculDaysBetweenTwoDate from '@/services/general/calculDaysBetweenTwoDate';

function selectionDate(dates, arrayJourSelected) {
  const arrayPeriode = [];

  const numDateDebut = Moment(dates.dateDebut).weekday();

  const iterations = calculDaysBetweenTwoDate(dates.dateFin, dates.dateDebut);

  const currentDate = dates.dateDebut;

  arrayJourSelected.forEach((el) => {
    let currentNumero = numDateDebut;
    for (let i = 0; i <= iterations; i += 1) {
      if (el.numero === currentNumero) {
        arrayPeriode.push(Moment(currentDate).add(i, 'days'));
      }
      currentNumero = (currentNumero + 1) % 7;
    }
  });
  return arrayPeriode;
}

export default function selectionPeriodeBrief(dates, joursSelected) {
  const arrayDates = selectionDate(dates, joursSelected);
  return arrayDates;
}
